export const LOADING_FORM_PATIENT = 'LOADING_FORM_PATIENT';
export const ERROR_FORM_PATIENT = 'ERROR_FORM_PATIENT';
export const RESET_FORM_PATIENT = 'RESET_FORM_PATIENT';
